"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BandwidthEstimationHybrid_1 = require("../../Bandwidth/BandwidthEstimationHybrid");
function createBandwidthEstimation(shaka) {
    var bandwidthEstimation = new BandwidthEstimationHybrid_1.default(shaka);
    return bandwidthEstimation;
}
exports.default = createBandwidthEstimation;
//# sourceMappingURL=createBandwidthEstimation.js.map